import { Link, useLocation } from 'react-router-dom';

import { appNavItems } from '@/components/appNavItems';
import { useDueTrainingCount } from '@/contexts/DueTrainingCountContext';
import { cn } from '@/services/utils';

const isRouteActive = (pathname: string, path: string) =>
  pathname === path || pathname.startsWith(`${path}/`);

// Mobile counterpart to AppTopHeader's nav pills, shown on every app route. Mirrors
// AppTopHeader.tsx's nav exactly: same 3 items (from appNavItems), same active-state colors, same
// Training due-count pill treatment.
export function MobileTabBar({ className }: { className?: string }) {
  const { pathname } = useLocation();
  const { dueCount } = useDueTrainingCount();

  return (
    <nav
      aria-label="Main navigation"
      className={cn(
        'fixed inset-x-0 bottom-0 z-20 flex h-16 items-stretch border-t border-[#ece9e2] bg-white pb-[env(safe-area-inset-bottom)] font-[family-name:var(--font-meaning-sans)]',
        className
      )}
    >
      {appNavItems.map((item) => {
        const Icon = item.icon;
        const active = isRouteActive(pathname, item.path);

        return (
          <Link
            key={item.path}
            to={item.path}
            state={item.path === '/training' ? { showTrainingModePicker: true } : undefined}
            replace={item.path === '/training' && active}
            className="relative flex flex-1 flex-col items-center justify-center gap-0.5"
          >
            <span
              className={cn(
                'flex size-9 items-center justify-center rounded-full transition',
                active ? 'bg-[#f1efe9] text-[#1e1c18]' : 'text-[#57534a]'
              )}
            >
              <Icon className="size-5" />
            </span>
            <span className={cn('text-[11px] font-semibold', active ? 'text-[#1e1c18]' : 'text-[#57534a]')}>
              {item.label}
            </span>
            {item.path === '/training' && !!dueCount && (
              <span className="absolute right-[22%] top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-[#2f5c4e] px-1 text-[10px] font-bold leading-none text-white">
                {dueCount}
              </span>
            )}
          </Link>
        );
      })}
    </nav>
  );
}
